/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Token_Icon_View_Asset_LabelInputs */

const en_components_token_icon_view_asset_label = /** @type {(inputs: Components_Token_Icon_View_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View asset`)
};

const de_components_token_icon_view_asset_label = /** @type {(inputs: Components_Token_Icon_View_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset anzeigen`)
};

const pt_br2_components_token_icon_view_asset_label = /** @type {(inputs: Components_Token_Icon_View_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver ativo`)
};

const tr_components_token_icon_view_asset_label = /** @type {(inputs: Components_Token_Icon_View_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varlığı görüntüle`)
};

const zh_cn2_components_token_icon_view_asset_label = /** @type {(inputs: Components_Token_Icon_View_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看资产`)
};

const zh_hk2_components_token_icon_view_asset_label = /** @type {(inputs: Components_Token_Icon_View_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看 asset`)
};

const ko_kr2_components_token_icon_view_asset_label = /** @type {(inputs: Components_Token_Icon_View_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자산 보기`)
};

const ru_ru2_components_token_icon_view_asset_label = /** @type {(inputs: Components_Token_Icon_View_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть актив`)
};

const es_419_components_token_icon_view_asset_label = /** @type {(inputs: Components_Token_Icon_View_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver activo`)
};

/**
* | output |
* | --- |
* | "View asset" |
*
* @param {Components_Token_Icon_View_Asset_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_token_icon_view_asset_label = /** @type {((inputs?: Components_Token_Icon_View_Asset_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Token_Icon_View_Asset_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_token_icon_view_asset_label(inputs)
	if (locale === "de") return de_components_token_icon_view_asset_label(inputs)
	if (locale === "pt-BR") return pt_br2_components_token_icon_view_asset_label(inputs)
	if (locale === "tr") return tr_components_token_icon_view_asset_label(inputs)
	if (locale === "zh-CN") return zh_cn2_components_token_icon_view_asset_label(inputs)
	if (locale === "zh-HK") return zh_hk2_components_token_icon_view_asset_label(inputs)
	if (locale === "ko-KR") return ko_kr2_components_token_icon_view_asset_label(inputs)
	if (locale === "ru-RU") return ru_ru2_components_token_icon_view_asset_label(inputs)
	return es_419_components_token_icon_view_asset_label(inputs)
});